module.exports = __webpack_public_path__ + "static/6-a159d29cc93d6abc4d2d8277468f565a.jpg";